import React from 'react';

const InfoBanner = ({ info, success, local }) => (
  <div className={`info-banner ${success ? 'success' : 'fail'} ${local ? 'local' : ''}`}>
    {info}
  </div>
)

export default InfoBanner;


// WEBPACK FOOTER //
// ./src/containers/components/info-banner.js